module.exports = __webpack_public_path__ + "img/vrijwilliger.f642e0bc.png";